import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OnOrbitActions } from "../../actions/on-orbit.actions";
import { OnOrbitState } from "../../models/on-orbit/on-orbit.state";

export const initialOnOrbitState: OnOrbitState = {
	search: { satNos: [], loading: false },
	unresolvedSatNos: []
};

const reducer = createReducer(
	initialOnOrbitState,
	on(OnOrbitActions.onorbit.getApi, (state, { params }) => ({
		...state,
		search: { ...state.search, params, loading: true }
	})),
	on(OnOrbitActions.onorbit.getSuccess, (state, { params, onorbit }) => ({
		...state,
		error: undefined,
		onorbit: _.unionBy(onorbit, state.onorbit ?? [], "satNo"),
		search: { params, satNos: onorbit.map((o) => o.satNo).filter((no): no is number => no != null), loading: false }
	})),
	on(OnOrbitActions.onorbit.getFail, (state, { error }) => ({
		...state,
		error,
		search: { ...state.search, satNos: [], loading: false }
	})),
	on(OnOrbitActions.onorbit.lookupSuccess, (state, { onorbit, requested }) => {
		const found = new Set(onorbit.map((o) => o.satNo));
		const unresolved = requested.filter((satNo) => !found.has(satNo));
		return {
			...state,
			onorbit: _.unionBy(onorbit, state.onorbit ?? [], "satNo"),
			unresolvedSatNos: _.union(state.unresolvedSatNos, unresolved)
		};
	}),
	on(OnOrbitActions.onorbit.lookupFail, (state, { error }) => ({ ...state, error }))
);

export function onOrbitReducer(state: OnOrbitState | undefined, action: Action): OnOrbitState {
	return reducer(state, action);
}
